// 운전자 마이크 MediaStream 공유 접근 seam.
//
// 마이크 스트림의 "소유자"는 여전히 Communicator(localMicStreamRef, getUserMedia)이며,
// 여기서는 그 라이브 스트림을 표시 전용으로(예: 오디오 레벨 게이지) 다른 컴포넌트가
// 읽을 수 있도록 모듈 레벨 ref + 구독자 알림만 제공한다. 데이터/시그널링 경로와 무관하며
// 오디오 송수신 로직은 일절 변경하지 않는다(가장 침습이 적은 접근 방식).
//
// - Communicator 가 getUserMedia 성공/해제 시 setLocalMicStream() 으로 등록/해제한다.
// - 게이지 컴포넌트는 subscribeLocalMicStream() 으로 현재/이후 스트림을 받는다.

type LocalMicStreamListener = (stream: MediaStream | null) => void;

let currentStream: MediaStream | null = null;
const listeners = new Set<LocalMicStreamListener>();

// 현재 등록된 운전자 마이크 스트림(없으면 null).
export function getLocalMicStream(): MediaStream | null {
  return currentStream;
}

// Communicator 전용 — 마이크 스트림 등록/해제. 구독자에게 즉시 통지한다.
export function setLocalMicStream(stream: MediaStream | null): void {
  if (currentStream === stream) {
    return;
  }
  currentStream = stream;
  listeners.forEach((listener) => {
    try {
      listener(stream);
    } catch {
      // 구독자 콜백 오류가 다른 구독자 통지를 막지 않도록 무시.
    }
  });
}

// 마이크 스트림 변경 구독. 등록 즉시 현재 값을 1회 통지하고, 해제 함수를 반환한다.
export function subscribeLocalMicStream(
  listener: LocalMicStreamListener,
): () => void {
  listeners.add(listener);
  listener(currentStream);
  return () => {
    listeners.delete(listener);
  };
}
